module.exports = __webpack_public_path__ + "static/media/bot.019a7b86.gif";